import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable, of } from 'rxjs';
import { Collection, Review, Performance, Pagination, Award, PerformanceRequestParams } from '@shared/interfaces';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CollectionsService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(params?: any): Observable<Pagination<Collection>>{
    return this.http.get<Pagination<Collection>>(this.api.COLLECTION(), { params });
  }

  get(id: number): Observable<Collection>{
    return this.http.get<Collection>(this.api.COLLECTION(id));
  }

  getPerformances(id: number, params?: PerformanceRequestParams): Observable<Pagination<Performance>>{
    return this.http.get<Pagination<{ performance: Performance, order: number }>>(this.api.COLLECTION_PERFORMANCES(id), { params: params as any })
      .pipe(map(data => {
        return {
          items: data.items.map(e => ({
            ...e.performance,
            order: e.order
          })),
          metaData: data.metaData
        }
      }), catchError(() => of({ items: [], metaData: {} })))
  }

  getReviews(id: number): Observable<Review[]>{
    return this.http.get<Pagination<Review>>(this.api.COLLECTION_REVIEWS(id))
      .pipe(map(item => item.items));
  }

  getAwards(id: number): Observable<Award[]>{
    return this.http.get<Pagination<Award>>(this.api.COLLECTION_AWARDS(id))
      .pipe(map(item => item.items));
  }

}
